angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.stateMachineOrderWidgetController', ['$scope', 'platformWebApp.bladeNavigationService', 'virtoCommerce.marketplaceModule.webApi',
        function ($scope, bladeNavigationService, smApi) {
            $scope.blade = $scope.widget.blade;

            $scope.refreshWidgetData = function (entityId) {
                smApi.searchStateMachineInstance({ objectTypes: ['VirtoCommerce.OrdersModule.Core.Model.CustomerOrder', 'VirtoCommerce.MarketplaceVendorModule.Core.Domains.SellerOrder'], objectIds: [entityId], take: 1 }, function (response) {
                    if (response.totalCount > 0) {
                        $scope.smName = response.results[0].stateMachineName;
                        $scope.smState = response.results[0].currentStateName;
                        $scope.smInstance = response.results[0];
                    }
                })
            };

            $scope.openBlade = function () {
                var blade = {
                    id: "stateMachineOrderDetail",
                    isNew: false,
                    controller: 'virtoCommerce.marketplaceModule.stateMachineOrderDetailController',
                    template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/state-machine-order-detail.tpl.html',
                    subtitle: '',
                    currentEntity: $scope.smInstance
                };
                bladeNavigationService.showBlade(blade, $scope.blade);
            };

            $scope.refreshWidgetData($scope.blade.currentEntityId);

    }]);
